import React, { useState, useEffect } from "react";
import { FaBars, FaTimes, FaChevronDown, FaChevronRight } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../index.css";
/*
const SyntheraLogo = ({
  textColor = "#FAFBFB",
  className,
  width = "1600",
  height = "504",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 1258 397"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >

*/
const SyntheraLogo = ({
  textColor = "#FAFBFB",
  className,
  width = "100%",
  // height = "auto", // Keep this auto!
}) => (
  <svg
    width={width}
    // height={height}
    viewBox="0 0 1650 500"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    // style={style} // Apply the style here
    // preserveAspectRatio="xMinYMid meet"
  >
    <path
      d="M360.866 194.315H453.215C455.655 194.315 457.049 195.535 457.049 198.149V215.05C457.049 217.49 455.655 218.884 453.215 218.884H365.919C359.646 218.884 356.684 221.846 356.684 228.293V234.217C356.684 240.49 359.472 243.104 365.919 243.104H431.086C450.602 243.104 461.579 254.255 461.579 273.771V287.884C461.579 305.832 450.776 316.286 430.738 316.286H334.207C331.593 316.286 330.373 315.066 330.373 312.453V295.551C330.373 293.112 331.593 291.718 334.207 291.718H425.685C431.783 291.718 434.92 288.756 434.92 282.309V275.165C434.92 268.892 432.306 266.278 425.859 266.278H360.518C341.002 266.278 330.199 255.127 330.199 235.611V222.717C330.199 204.77 340.828 194.315 360.866 194.315Z"
      fill={textColor}
    />
    <path
      d="M477.683 194.315H502.077C504.168 194.315 505.214 194.838 506.259 196.406L552.085 257.217L598.086 196.406C599.305 194.838 600.351 194.315 602.267 194.315H625.616C627.707 194.315 628.404 196.058 627.184 197.8L564.631 278.998V312.453C564.631 314.892 563.237 316.286 560.623 316.286H541.979C539.365 316.286 537.971 314.892 537.971 312.453V278.998L475.941 197.8C474.721 196.058 475.592 194.315 477.683 194.315Z"
      fill={textColor}
    />
    <path
      d="M660.545 194.315H676.227C688.773 194.315 690.864 196.929 696.439 204.596L760.561 289.627C761.084 290.498 761.781 290.847 762.826 290.847H764.394C765.266 290.847 765.788 290.324 765.788 289.104V198.149C765.788 195.535 767.008 194.315 769.622 194.315H788.266C790.88 194.315 792.099 195.535 792.099 198.149V298.165C792.099 311.93 787.395 316.286 776.417 316.286H760.91C748.364 316.286 746.273 313.672 740.872 306.006L676.576 220.975C675.879 220.104 675.356 219.755 674.31 219.755H672.742C671.697 219.755 671.348 220.278 671.348 221.497V312.453C671.348 315.066 669.954 316.286 667.515 316.286H648.871C646.257 316.286 645.037 315.066 645.037 312.453V212.437C645.037 198.672 649.568 194.315 660.545 194.315Z"
      fill={textColor}
    />
    <path
      d="M815.019 194.315H951.278C953.891 194.315 955.285 195.535 955.285 198.149V215.225C955.285 217.838 953.891 219.058 951.278 219.058H896.391V312.453C896.391 315.066 895.346 316.286 892.732 316.286H873.739C871.3 316.286 869.906 315.066 869.906 312.453V219.058H815.019C812.58 219.058 811.186 217.838 811.186 215.225V198.149C811.186 195.535 812.58 194.315 815.019 194.315Z"
      fill={textColor}
    />
    <path
      d="M1086.32 194.315H1105.14C1107.76 194.315 1109.15 195.535 1109.15 198.149V312.453C1109.15 315.066 1107.76 316.286 1105.14 316.286H1086.32C1083.89 316.286 1082.49 315.066 1082.49 312.453V266.627H1000.95V312.453C1000.95 315.066 999.726 316.286 997.112 316.286H978.294C975.68 316.286 974.46 315.066 974.46 312.453V198.149C974.46 195.535 975.68 194.315 978.294 194.315H997.112C999.726 194.315 1000.95 195.535 1000.95 198.149V242.929H1082.49V198.149C1082.49 195.535 1083.89 194.315 1086.32 194.315Z"
      fill={textColor}
    />
    <path
      d="M1183.25 194.315H1259.92C1262.35 194.315 1263.75 195.535 1263.75 198.149V215.05C1263.75 217.49 1262.35 218.884 1259.92 218.884H1183.42C1165.48 218.884 1160.77 223.937 1160.77 242.232V243.104H1258.87C1261.31 243.104 1262.7 244.323 1262.7 246.937V262.445C1262.7 265.058 1261.31 266.278 1258.87 266.278H1160.77V268.369C1160.77 286.665 1165.48 291.718 1183.42 291.718H1259.92C1262.35 291.718 1263.75 293.112 1263.75 295.551V312.453C1263.75 315.066 1262.35 316.286 1259.92 316.286H1183.25C1147.88 316.286 1134.46 303.566 1134.46 270.286V240.316C1134.46 207.035 1147.88 194.315 1183.25 194.315Z"
      fill={textColor}
    />
    <path
      d="M1292.61 194.315H1386C1411.96 194.315 1423.46 205.99 1423.46 230.035V240.142C1423.46 260.354 1415.45 272.202 1398.2 275.687L1427.3 311.756C1428.69 313.498 1427.82 316.286 1425.03 316.286H1401.68C1398.89 316.286 1398.02 315.589 1396.8 314.021L1369.1 278.649H1313.86V312.453C1313.86 315.066 1312.64 316.286 1310.03 316.286H1291.21C1288.6 316.286 1287.38 315.066 1287.38 312.453V199.543C1287.38 196.058 1289.12 194.315 1292.61 194.315ZM1313.86 255.649H1380.6C1392.45 255.649 1396.8 251.467 1396.8 241.013V233.695C1396.8 223.066 1392.27 218.71 1380.6 218.71H1316.13C1314.56 218.71 1313.86 219.232 1313.86 220.626V255.649Z"
      fill={textColor}
    />
    <path
      d="M1515.51 194.315H1525.79C1534.85 194.315 1540.08 196.929 1545.83 207.558L1603.5 312.279C1604.72 314.718 1604.2 316.286 1601.41 316.286H1579.28C1577.02 316.286 1575.97 315.763 1575.28 314.195L1563.78 292.937H1480.31L1468.99 314.195C1468.12 315.763 1467.25 316.286 1464.98 316.286H1442.15C1439.37 316.286 1438.84 314.718 1440.06 312.279L1497.22 207.558C1502.79 196.929 1508.19 194.315 1515.51 194.315ZM1492.51 270.286H1551.4L1524.4 220.278C1523.87 219.407 1523.18 219.058 1522.31 219.058H1521.26C1520.39 219.058 1519.87 219.407 1519.34 220.278L1492.51 270.286Z"
      fill={textColor}
    />
    <path
      d="M192.127 141L59 274.127H192.127V326.11H84.3575C70.3529 326.11 59 314.757 59 300.752V274.127V218.701C59 211.976 61.6716 205.526 66.427 200.77L126.197 141H192.127Z"
      fill="url(#paint0_linear_4_195)"
    />
    <path
      d="M141.412 378.092L274.539 244.966H141.412V192.983H249.181C263.186 192.983 274.539 204.336 274.539 218.34V244.966V300.392C274.539 307.117 271.867 313.567 267.112 318.322L207.341 378.092H141.412Z"
      fill="url(#paint1_linear_4_195)"
    />
    <g
      clipPath="url(#clip0_4_298)"
      // transform="translate(330,342) scale(1.7) translate(-330,-342)"
      // stroke="#032D28"
      // strokeWidth="0.6"
    >
      <path
        d="M363.575 363.259V367.295C363.575 371.305 361.402 373.251 356.925 373.251H330.387V370.565H355.478C358.449 370.565 360.292 368.703 360.292 365.699V363.662C360.292 360.664 358.553 358.944 355.53 358.944H336.843C332.47 358.944 330.342 356.79 330.342 352.346V348.66C330.342 344.651 332.502 342.704 336.94 342.704H362.278V345.39H338.387C335.377 345.39 333.573 347.207 333.573 350.257V351.95C333.573 354.941 335.331 356.661 338.387 356.661H357.022C361.369 356.661 363.575 358.88 363.575 363.259Z"
        fill={textColor}
      />
      <path
        d="M412.336 354.24V356.661H441.488V358.944H412.336V361.715C412.336 368.164 414.678 370.565 420.985 370.565H441.787V373.251H420.933C412.012 373.251 409.15 370.578 409.15 362.26V353.689C409.15 345.377 412.012 342.704 420.933 342.704H441.787V345.39H420.985C414.678 345.39 412.336 347.791 412.336 354.24Z"
        fill={textColor}
      />
      <path
        d="M490.605 354.442V361.514C490.605 367.989 493.07 370.513 499.403 370.513H520.503V373.251H499.15C490.235 373.251 487.367 370.578 487.367 362.26V353.689C487.367 345.377 490.235 342.704 499.15 342.704H520.503V345.442H499.403C493.07 345.442 490.605 347.966 490.605 354.442Z"
        fill={textColor}
      />
      <path
        d="M603.852 342.704V362.26C603.852 370.578 600.991 373.251 592.07 373.251H577.769C568.848 373.251 565.986 370.578 565.986 362.26V342.704H569.218V361.514C569.218 367.989 571.683 370.513 578.016 370.513H591.823C598.117 370.513 600.569 367.989 600.569 361.514V342.704H603.852Z"
        fill={textColor}
      />
      <path
        d="M685.209 353.643V350.75C685.209 344.962 682.815 342.704 676.664 342.704H650.633V373.251H653.864V362.487H672.888L681.316 373.251H684.982L676.223 362.39L679.727 361.683C682.439 361.131 685.209 359.749 685.209 353.643ZM675.12 360.249H653.864V348.063C653.864 346.461 655.025 345.345 656.68 345.345H675.12C679.636 345.345 681.926 347.512 681.926 351.801V353.89C681.926 358.107 679.636 360.249 675.12 360.249Z"
        fill={textColor}
      />
      <path
        d="M734.861 342.704H731.623V373.251H734.861V342.704Z"
        fill={textColor}
      />
      <path
        d="M816.444 342.704V345.442H799.6V373.251H796.362V345.442H779.57V342.704H816.444Z"
        fill={textColor}
      />
      <path
        d="M896.342 342.704L879.926 364.018V373.251H876.637V364.018L860.357 342.704H863.868L878.505 362.124L893.195 342.704H896.342Z"
        fill={textColor}
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4_195"
        x1="259.262"
        y1="242.282"
        x2="38.7138"
        y2="329.913"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0BAA42" />
        <stop offset="1" stopColor="#05663D" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4_195"
        x1="259.262"
        y1="242.282"
        x2="38.7138"
        y2="329.913"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0BAA42" />
        <stop offset="1" stopColor="#05663D" />
      </linearGradient>
      <clipPath id="clip0_4_195">
        <rect
          width="566"
          height="30.5472"
          fill="white"
          transform="translate(330.342 342.704)"
        />
      </clipPath>
    </defs>
  </svg>
);

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [mobileDropdown, setMobileDropdown] = useState(null);
  const [mobileSubOpen, setMobileSubOpen] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(null);

  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [mobileOpen]);

  const handleLogoClick = (e) => {
    if (location.pathname === "/") {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    setMobileOpen(false);
  };

  const menuItems = [
    {
      title: "Solutions",
      dropdown: [
        {
          name: "Enterprise Cyber Security",
          link: "/solutions/enterprise-Cyber-Security",
        },
        {
          name: " AI Security and Governance",
          link: "/solutions/ai-security-and-governance",
        },
        {
          name: "Security Operations & Analytics",
          link: "/solutions/Data-Analytics",
        },
      ],
    },
    {
      title: "Services",
      dropdown: [
        {
          name: "Security Consultation",
          link: "/services/security-consulting-advisory",
        },
        { name: "Design and Deploy", link: "/services/design-and-deploy" },
        {
          name: "Managed Security Services",
          link: "/services/managed-security-services",
        },
        {
          name: "Managed Detection and Response",
          link: "/services/detection-and-response",
        },
        { name: "Incident Response", link: "/services/incident-response" },
      ],
    },
    { title: "Resources", link: "/Resources" },
    { title: "Partners", link: "/partnersPage" },
    {
      title: "Company",
      dropdown: [
        { name: "About Us", link: "/company/about" },
        {
          name: "Industries",
          link: "/company/industries",
          subItems: [
            { name: "Healthcare", link: "/industries/healthcare" },
            {
              name: "Mining & Manufacturing",
              link: "/industries/mining-manufacturing",
            },
            { name: "Logistics", link: "/industries/logistics" },
            { name: "Technology", link: "/industries/technology" },
            {
              name: "Retail & Hospitality",
              link: "/industries/retail-hospitality",
            },
            {
              name: "Finance & Insurance",
              link: "/industries/finance-insurance",
            },
          ],
        },
        { name: "Careers", link: "/company/careers" },
      ],
    },
    { title: "Contact", link: "/contact" },
  ];

  const linkClasses = `relative transition-colors duration-300 font-medium no-underline ${
    isScrolled
      ? "text-gray-900 hover:text-green-600"
      : "text-gray-200 hover:text-green-500"
  }`;

  const dropdownLinkClasses =
    "block px-4 py-2 text-gray-700 hover:bg-green-50 hover:text-green-600 transition no-underline flex justify-between items-center";

  // ★ IMPROVED: Slimmer, small-letter expert button styles
  const expertButtonClasses =
    "relative overflow-hidden px-4 py-2 rounded-full border-2 border-[#00C08B] text-[#00C08B] font-semibold uppercase tracking-wider transition-colors duration-300 group no-underline text-sm flex items-center justify-center";

  return (
    <nav
      id="main-navbar"
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? "bg-white shadow-md" : "bg-transparent"
      } rounded-b-3xl`}
    >
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center h-20">
        <Link
          to="/"
          className="flex items-center group no-underline"
          onClick={handleLogoClick}
        >
          <SyntheraLogo
            textColor={isScrolled ? "#111827" : "#FFFFFF"}
            className="h-16 w-auto transition-transform duration-300 "
          />
        </Link>

        {/* Desktop Menu */}
        <ul className="hidden md:flex items-center space-x-6 font-medium mb-0">
          {menuItems.map((item, index) => (
            <li
              key={index}
              className="relative group py-2"
              onMouseEnter={() => setOpenDropdown(index)}
              onMouseLeave={() => setOpenDropdown(null)}
            >
              <Link to={item.link || "#"} className={linkClasses}>
                {item.title}{" "}
                {(item.dropdown || item.megaMenu) && (
                  <FaChevronDown className="ml-1 text-sm inline-block" />
                )}
              </Link>
              {item.dropdown && openDropdown === index && (
                <div className="absolute left-0 top-full w-64 bg-white rounded-lg shadow-lg py-3 z-50 animate-slideDown">
                  {item.dropdown.map((subItem, subIndex) =>
                    subItem.subItems ? (
                      <div
                        key={subIndex}
                        className="relative"
                        onMouseEnter={() => setOpenSubMenu(subIndex)}
                        onMouseLeave={() => setOpenSubMenu(null)}
                      >
                        <Link to={subItem.link} className={dropdownLinkClasses}>
                          {subItem.name}
                          <FaChevronRight className="text-xs" />
                        </Link>
                        {openSubMenu === subIndex && (
                          <div className="absolute left-full top-0 w-64 bg-white rounded-lg shadow-lg py-3 z-50">
                            {subItem.subItems.map((industry, iIdx) => (
                              <Link
                                key={iIdx}
                                to={industry.link}
                                className="block px-4 py-2 text-gray-700 hover:bg-green-50 hover:text-green-600 transition no-underline"
                              >
                                {industry.name}
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>
                    ) : (
                      <Link
                        key={subIndex}
                        to={subItem.link}
                        className={dropdownLinkClasses}
                      >
                        {subItem.name}
                      </Link>
                    ),
                  )}
                </div>
              )}
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center space-x-4">
          <Link to="/under-attack" className={expertButtonClasses}>
            <span className="absolute inset-0 w-full h-full bg-[#259273] transition-transform duration-300 ease-out -translate-x-full group-hover:translate-x-0"></span>
            <span className="relative z-10 group-hover:text-white transition-colors duration-300">
              Under Attack?
            </span>
          </Link>
        </div>

        <button
          aria-label="Open mobile menu"
          className={`md:hidden p-2 rounded-lg border shadow-sm transition-all duration-300 hover:bg-gray-100 ${
            isScrolled
              ? "border-gray-200 text-gray-900"
              : "border-gray-800 text-white"
          }`}
          onClick={() => setMobileOpen(true)}
        >
          <FaBars className="text-2xl" />
        </button>
      </div>

      {/* Mobile Sidebar */}
      <div
        className={`fixed top-0 right-0 h-full w-4/5 sm:w-2/3 shadow-2xl transform transition-all duration-500 ease-in-out z-50 flex flex-col ${
          mobileOpen ? "translate-x-0 bg-white" : "translate-x-full"
        }`}
      >
        {/* HEADER - FIXED */}
        <div className="flex justify-between items-center p-4 border-b border-gray-100 bg-white">
          <SyntheraLogo
            textColor="#111827"
            className="h-14 w-auto transition-all"
          />{" "}
          <button
            aria-label="Close mobile menu"
            onClick={() => setMobileOpen(false)}
            className="text-2xl text-gray-400 hover:text-gray-600 transition-colors"
          >
            <FaTimes />
          </button>
        </div>

        {/* SCROLLABLE MENU AREA */}
        <nav className="flex-1 px-6 py-4 space-y-2 overflow-y-auto">
          {menuItems.map((item, index) => (
            <div key={index} className="border-b border-gray-50 last:border-0">
              {item.dropdown ? (
                <>
                  <button
                    aria-label="Toggle mobile dropdown menu"
                    className="flex justify-between items-center w-full text-gray-900 font-bold text-lg py-4"
                    onClick={() =>
                      setMobileDropdown(index === mobileDropdown ? null : index)
                    }
                  >
                    {item.title}
                    <FaChevronDown
                      className={`text-sm transition-transform duration-300 ${
                        mobileDropdown === index
                          ? "rotate-180 text-[#00C08B]"
                          : "opacity-20"
                      }`}
                    />
                  </button>
                  <div
                    className={`transition-all duration-500 overflow-hidden ${
                      mobileDropdown === index
                        ? "max-h-[1000px] opacity-100 mb-4"
                        : "max-h-0 opacity-0"
                    }`}
                  >
                    {item.dropdown.map((subItem, subIndex) => (
                      <div key={subIndex} className="mb-1">
                        {subItem.subItems ? (
                          <div className="bg-gray-50/50 rounded-xl p-1">
                            <button
                              aria-label="Toggle mobile submenu"
                              className="flex justify-between items-center w-full text-gray-600 px-4 py-3 font-semibold text-sm"
                              onClick={() => setMobileSubOpen(!mobileSubOpen)}
                            >
                              {subItem.name}
                              <FaChevronDown
                                className={`text-[10px] transition-transform ${mobileSubOpen ? "rotate-180" : ""}`}
                              />
                            </button>
                            {mobileSubOpen && (
                              <div className="pl-6 flex flex-col gap-1 pb-2">
                                {subItem.subItems.map((ind, iIdx) => (
                                  <Link
                                    key={iIdx}
                                    to={ind.link}
                                    className="text-gray-500 py-2 text-sm no-underline border-l-2 border-transparent hover:border-[#00C08B] hover:pl-2 transition-all"
                                    onClick={() => setMobileOpen(false)}
                                  >
                                    {ind.name}
                                  </Link>
                                ))}
                              </div>
                            )}
                          </div>
                        ) : (
                          <Link
                            to={subItem.link}
                            className="block text-gray-600 pl-4 py-3 no-underline text-sm font-medium hover:text-[#00C08B] transition-colors"
                            onClick={() => setMobileOpen(false)}
                          >
                            {subItem.name}
                          </Link>
                        )}
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <Link
                  to={item.link}
                  className="block text-lg font-bold text-gray-900 no-underline py-4"
                  onClick={() => setMobileOpen(false)}
                >
                  {item.title}
                </Link>
              )}
            </div>
          ))}
        </nav>

        {/* COOL SLIM EMERGENCY BUTTON - PINNED TO BOTTOM */}
        <div className="p-6 bg-white border-t border-gray-50">
          <Link
            to="/under-attack"
            className="group relative flex items-center justify-center w-full py-3 px-6 bg-[#00C08B] text-white rounded-full font-bold text-xs uppercase tracking-[0.2em] no-underline overflow-hidden shadow-lg shadow-emerald-500/20 active:scale-95 transition-all duration-300"
            onClick={() => setMobileOpen(false)}
          >
            {/* Pulsing background effect */}
            <span className="absolute inset-0 bg-white/20 animate-ping rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>

            <span className="relative z-10 flex items-center gap-2">
              Emergency Response
              <div className="w-1.5 h-1.5 bg-white rounded-full animate-pulse shadow-[0_0_8px_white]"></div>
            </span>
          </Link>
        </div>
      </div>

      {mobileOpen && (
        <div
          className="fixed inset-0 backdrop-blur-sm z-40"
          onClick={() => setMobileOpen(false)}
        ></div>
      )}
    </nav>
  );
};

export default Navbar;
